module.exports = __webpack_public_path__ + "static/img/folder.8396d31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/folder.png
// module id = yPcg
// module chunks = 1